export default __webpack_public_path__ + "static/media/MyRiadPro-Light.1d169f60.otf";